import secureLocalStorage from "react-secure-storage";
import { Popup } from "@progress/kendo-react-popup";
import React from "react";
import { PureComponent } from "react";
import { TextArea } from "@progress/kendo-react-inputs";
import * as moment from "moment";
import { CircularProgress } from "@material-ui/core";

export default class TaskProgressPopup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      temp: undefined, //this.props.dataItem[this.props.field],
      historyList: [],
      flag: true,
      loader: false,
    };
  }

  handleChange = (e) => {
    this.setState({ temp: e.value });
  };
  onSubmit = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.temp,
    });
    let updateData = {
      ...this.props.dataItem,
      [this.props.field]: this.state.temp,
    };
    this.props.updateDropdownValue(updateData);
    this.closePopup();
  };

  handleEditCell = () => {
      this.props.onEditCell(this.props.dataItem, this.props.field);
  };
  closePopup = () => {
    this.props.exitEdit();
  };
  handleOnBlur = (e) => {
    return;
  };

  render() {
    const { dataItem, field } = this.props;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = dataItem.userId;
    const value = this.props.dataItem[this.props.field];
    const isClosed = dataItem.isClosed === "Closed";
    if (
      (this.props.field && this.props.field === this.props.dataItem.inEdit) ||
      this.props.dataItem.inEdit === true
    ) {
      return (
        <td>
          <Popup
            show={this.props.field === this.props.dataItem.inEdit}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont stackHolderSelection">
              <label className="fieldLabel">Add comments</label>
              <br></br>
              <div className="row cmttextarea">
                <div className="col-sm-3 col-md-7">
                  <TextArea
                    onChange={this.handleChange}
                    onBlur={this.handleOnBlur}
                    disabled={isClosed}
                  />
                </div>
                <div className="col-sm-3 col-md-3">
                  <div className="progressBtn">
                    <button
                      className="greenbtn"
                      type="button"
                      onClick={this.onSubmit}
                      disabled={!this.state.temp||isClosed}
                    >
                      Submit
                    </button>
                    &nbsp;&nbsp;
                    <button
                      onClick={this.closePopup}
                      className="redbtn"
                      type="button"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
              <br></br>
              <label className="fieldLabel">Progress History</label>
              <div className="commentsHistory">
                <ul className="comments">
                  {this.props.dataItem?.taskProgressComments?.map((item) => (
                    <li>
                      <p>{item.taskComment}</p>
                      <small>
                        Date:
                        {moment(new Date(item.createdDate)).format(
                          "DD-MMM-yyyy HH:mm:ss"
                        )}
                      </small>{" "}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                      <small>Entered by:{item.userName}</small>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Popup>
        </td>
      );
    }
    if (this.props.dataItem.inEdit !== this.props.field) {
      if (loginUserId === ownerId) {
        return (
          <td
            onClick={this.handleEditCell}
            style={{ left: "437px", right: "0px" }}
            title={value}
          >
            <span>{value}</span>
          </td>
        );
      } else {
        return this.props.dataItem.role == "Standard User" ||
          this.props.dataItem.role == "View Only" ? (
          <td style={{ left: "290px", right: "0px" }} title={value}>
            <span>{value}</span>
          </td>
        ) : (
          <td
            onClick={this.handleEditCell}
            style={{ left: "437px", right: "0px" }}
            title={value}
          >
            <span>{value}</span>
          </td>
        );
      }
    }
  }
}
